import { Component } from 'react';
import CustomizedTextField from './CustomizedTextField';
import InfoButtonWithTooltip from './InfoButtonWithTooltip';
import PropTypes from 'prop-types';
import { TYPING_TIMEOUT } from '../../constants'
import { Icon, Chip, Accordion, AccordionSummary, AccordionDetails, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import './TextFieldWithSuggestions.css'

class TextFieldWithSuggestions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tabId: 0,
            expanded: false,
            chips: props.hasgrouping ? this.generateGroupedChips() : this.generateChips(),
            timeout: TYPING_TIMEOUT,
            typedJustNow: false,
            value: props.value, 
            filter: "",
            selectedChipsDictionary: {}          
        }
    }

    static getDerivedStateFromProps(props, state) {

        if (state.typedJustNow)
            return state;

        state.value = props.value;
        return state;
    }

    onChipClick(suggestion) {
        let oldValue = this.props.value;
        let newValue = oldValue;
        let selectedChipsDictionary = {...this.state.selectedChipsDictionary};

        if (this.props.hasgrouping) {
            if (!(suggestion.value.group_value in selectedChipsDictionary)) {
                selectedChipsDictionary[suggestion.value.group_value] = [suggestion.name];
            } else if (!selectedChipsDictionary[suggestion.value.group_value].includes(suggestion.name)) {
                selectedChipsDictionary[suggestion.value.group_value].push(suggestion.name);
            }
        }

        if (this.props.strict) {
            if (this.props.multiSelect) {
                if (this.props.hasgrouping) {
                    newValue = this.getThemesString(selectedChipsDictionary);
                } else {
                    newValue += suggestion.name
                }                
            }                
            else {
                newValue = suggestion.name
            }                
        } else {
            if (this.props.hasgrouping) {
                newValue = this.getThemesString(selectedChipsDictionary);
            } else {
                newValue += suggestion.name
            }
        }            

        if (this.props.multiline && ((this.props.strict && this.props.multiSelect) || !this.props.strict) && !this.props.hasgrouping)
            newValue += "\r\n";
        else if (this.props.strict && this.props.multiSelect && !this.props.hasgrouping)
            newValue += ", ";

        this.setState({
            value: newValue,
            selectedChipsDictionary: {...selectedChipsDictionary}
        })

        this.props.onValueChange(newValue);
    }

    getThemesString(selectedChipsDictionary) {
        let newValue = "";

        var dictionaryLength = Object.keys(selectedChipsDictionary).length;
        var j = 0;
        for(var key in selectedChipsDictionary) {
            var value = selectedChipsDictionary[key];
            newValue += key + " : ";
            var valueLength = value.length;
            var i = 0;
            value.forEach(v => {
                newValue += v;
                if (i !== valueLength - 1) {
                    newValue += ", "
                }
                i = i + 1;
            });
            if (j !== dictionaryLength - 1) {
                newValue += "\r\n"
            }
            j = j + 1;
        }

        return newValue;
    }

    handleChange(e) {
        let value = e.target.value

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        this.setState({
            value,
            typedJustNow: true,
            typingTimeout: setTimeout(() => {
                this.props.onValueChange(value);
                this.setState({
                    typedJustNow: false
                })
            }, this.state.timeout)
        });
    }

    handleChangeFilter(e) {
        let filter = e.target.value;

        this.setState({
            filter: filter
        });
    }

    clearFilter() {
        this.setState({
            filter: ""
        });
    }

    generateChips() {
        let chips = [];

        this.props.suggestions.forEach((s, index) => {
            chips.push(
                <div key={index}  className="margin-right row">
                    <div className='col-1' style={{justifyContent: "center", display: "flex"}}>
                        {s.value.description ? (
                            <InfoButtonWithTooltip description={s.value.description} />
                        ) : null}
                    </div>
                    <div className='col-11'>
                        <Chip 
                            sx={{
                                height: "auto !important",
                                minHeight: "32px",
                                '& .MuiChip-label': {
                                    whiteSpace: "pre-wrap"
                                }
                            }} 
                            key={index} label={s.name} onClick={this.onChipClick.bind(this, s)} element={s} />            
                    </div>         
                </div>
            )
        })

        return chips;
    }

    generateGroupedChips() {
        let chipsDictionary = {};
 
        this.props.suggestions.forEach((s) => {
            var keyIndex = 0;
            if (!(s.value.group_value in chipsDictionary)) {
                chipsDictionary[s.value.group_value] = [
                    <div key={keyIndex} className="margin-right row">
                        <div className='col-1' style={{justifyContent: "center", display: "flex"}}>
                            {s.value.description ? (
                                <InfoButtonWithTooltip description={s.value.description} />
                            ) : null}
                        </div>
                        <div className='col-11'>
                            <Chip 
                                sx={{
                                    height: "auto !important",     
                                    minHeight: "32px",                           
                                    '& .MuiChip-label': {
                                        whiteSpace: "pre-wrap"
                                    }
                                }}
                            key={keyIndex} label={s.name} onClick={this.onChipClick.bind(this, s)} element={s} />                 
                        </div>            
                    </div>
            ];
            } else {
                keyIndex = chipsDictionary[s.value.group_value].length;
                chipsDictionary[s.value.group_value].push(
                    <div key={keyIndex} className="margin-right row">
                        <div className='col-1' style={{justifyContent: "center", display: "flex"}}>
                            {s.value.description ? (
                                <InfoButtonWithTooltip description={s.value.description} />
                            ) : null} 
                        </div>
                        <div className='col-11'>
                            <Chip 
                                sx={{
                                    height: "auto !important",
                                    minHeight: "32px",
                                    '& .MuiChip-label': {
                                        whiteSpace: "pre-wrap"
                                    }
                                }}
                            key={keyIndex} label={s.name} onClick={this.onChipClick.bind(this, s)} element={s} />   
                        </div>                         
                    </div>
                );
            }
        })

        return chipsDictionary;
    }

    handleChangeTab = (event, value) => {
        this.setState({
            tabId: value,
        });
    };

    handleChangeIndex = (index) => {
        this.setState({
            tabId: index,
        });
    };

    setCurrentAccordion = (value) => {
        this.setState({
            expanded: this.state.expanded !== value ? value : ""
        });
    };


    clear() {
        this.setState({
            value: "",
            selectedChipsDictionary: {}
        });
        this.props.onValueChange("");
    }

    render() {
        let childrenProps = {...this.props};
        delete childrenProps.onValueChange;
        delete childrenProps.strict;
        delete childrenProps.multiSelect;
        delete childrenProps.hasgrouping;

        let chipsToVisualize;
        if (this.props.hasgrouping) {
            let accordions = [];

            var index = 0;
            for(var key in this.state.chips) {
                let themesChips = [];
                var value = this.state.chips[key];

                var regex = new RegExp(this.state.filter, "i");

                if ((this.state.filter !== "" && value.find(x => regex.test(x.props.children[1].props.children.props.label))) || this.state.filter === "") {
                    value.forEach(v => {
                        if (regex.test(v.props.children[1].props.children.props.label)) {
                            themesChips.push(v)
                        }
                    });

                    accordions.push(
                        <Accordion
                            value={key}
                            expanded={key === this.state.expanded}
                            sx={{
                                margin: "auto !important"
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                onClick={this.setCurrentAccordion.bind(this, key)}
                            >
                                <div
                                    className="col-lg-10 col-md-10 col-sm-10 col-10 without-side-padding"                                
                                >
                                    <Typography>
                                        {key}
                                    </Typography>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div key={index} className="div-top-padding">
                                    {themesChips}
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    );
                    index = index + 1.
                }                
            }

            chipsToVisualize = 
            <div className="div-top-padding">
                <div>
                    {accordions}
                </div>
            </div>;
        } else {
            chipsToVisualize = <div className="div-top-padding">{this.state.chips}</div> ; 
        }

        return (
            <div>
                {this.props.strict ? (
                    <>
                        <div className="row col-lg-12 col-md-12 col-sm-12 col-12 mb-3 px-3">
                            <OutlinedInput {...childrenProps} className="col-lg-12 col-md-12 col-sm-12 col-12 light-disabled" 
                                sx={{
                                    backgroundColor: '#d5eafc',
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderWidth: '0px'
                                    }
                                }} 
                                endAdornment={
                                    <InputAdornment position="start">
                                        <IconButton onClick={this.clear.bind(this)} color="primary" sx={{minWidth: "auto", padding: 0, pointerEvents: "auto"}}>
                                            <Icon className="red-icon">close</Icon>
                                        </IconButton>
                                    </InputAdornment>
                                }
                            value={this.state.value} onChange={this.handleChange.bind(this)} />
                        </div>
                        <div className="row col-lg-12 col-md-12 col-sm-12 col-12 px-3">
                            <CustomizedTextField {...childrenProps} className="col-lg-12 col-md-12 col-sm-12 col-12" 
                            sx={{
                                "& .MuiInputBase-root": {
                                    backgroundColor: '#FFFFFF'
                                }
                            }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><Icon>search</Icon></InputAdornment>,
                                endAdornment:
                                    <InputAdornment position="start">
                                        <IconButton onClick={this.clearFilter.bind(this)} color="primary" sx={{minWidth: "auto", padding: 0, pointerEvents: "auto"}}>
                                            <Icon className="red-icon">close</Icon>
                                        </IconButton>
                                    </InputAdornment>                                
                            }}
                            value={this.state.filter} onChange={this.handleChangeFilter.bind(this)} />
                            
                        </div>
                    </>
                ) : (
                    <CustomizedTextField {...childrenProps} className="col-lg-12 col-md-12 col-sm-12 col-12" value={this.state.value} onChange={this.handleChange.bind(this)} />
                )}
                {chipsToVisualize}  
            </div>
        )
    }
}

TextFieldWithSuggestions.propTypes = {
    suggestions: PropTypes.array.isRequired,
    onValueChange: PropTypes.func,
    value: PropTypes.string,
    multiline: PropTypes.bool,
    strict: PropTypes.bool,
    multiSelect: PropTypes.bool,
    hasgrouping: PropTypes.bool,
};

export default (TextFieldWithSuggestions);
